export default class WorkshopFilterMl {
  idPlanProduction: number;
  dates: Date[];
  typeJour: string;
}
